import { Controller } from "@hotwired/stimulus"

// Campaign wizard — messaging generation poll. The messaging step renders a
// processing panel while the ~60s AI draft runs; this controller polls the
// status endpoint and, once the campaign settles, reloads the step so the
// server renders the editable sequence (on completed) or the failed panel (on
// failed). Polling — not a blind interval reload — means exactly one reload, at
// the transition, instead of churning the panel every couple of seconds.
export default class extends Controller {
  static values = {
    statusUrl: String,
    interval: { type: Number, default: 2500 }
  }

  connect() {
    this.tick = this.tick.bind(this)
    this.timer = setInterval(this.tick, this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  async tick() {
    try {
      const res = await fetch(this.statusUrlValue, {
        headers: { "Accept": "application/json" }
      })
      if (!res.ok) return

      const data = await res.json()
      if (data.status === "completed" || data.status === "failed") {
        this.stop()
        // Re-render the step from the server: the editable sequence on success,
        // the failed panel (with a retry) on failure.
        Turbo.visit(window.location.href, { action: "replace" })
      }
    } catch (_error) {
      // Transient network hiccup — keep polling.
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
